import { Link } from "react-router";

import { PageTitle } from "../../components/AppLayout/components/Content/components";

export const TypographyDocs = () => {
    return (
        <>
            <PageTitle translationKey="Page Title L1" />
            <PageTitle translationKey="Page Title L2" />
            <PageTitle translationKey="Page Title L3" />
            <p>Text</p>
            <Link to="/">A Link</Link>
        </>
    );
};
